'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BaseIcon2 = require('./BaseIcon');

var _BaseIcon3 = _interopRequireDefault(_BaseIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Phone = function (_BaseIcon) {
  (0, _inherits3.default)(Phone, _BaseIcon);

  function Phone() {
    (0, _classCallCheck3.default)(this, Phone);
    return (0, _possibleConstructorReturn3.default)(this, (Phone.__proto__ || (0, _getPrototypeOf2.default)(Phone)).apply(this, arguments));
  }

  (0, _createClass3.default)(Phone, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        this.getSvgProps(),
        _react2.default.createElement('path', (0, _extends3.default)({ d: 'M70.64 115.256c.33-.37.7-.705 1.05-1.058.518-.523.522-1.157.007-1.676-.615-.62-1.23-1.235-1.85-1.85-.507-.5-1.14-.5-1.646 0-.383.382-.77.763-1.146 1.153-.026.027-.05.05-.076.064l-.264.262c-.074.047-.147.046-.242-.005-.248-.135-.513-.245-.752-.395-1.116-.7-2.052-1.604-2.88-2.62-.41-.507-.777-1.045-1.03-1.653-.043-.103-.044-.175.013-.25l.264-.266c.013-.017.027-.035.046-.052l.344-.337c.267-.265.53-.532.795-.798.526-.53.525-1.152-.004-1.686-.3-.302-.602-.602-.904-.903-.31-.31-.618-.624-.932-.93-.507-.5-1.14-.5-1.648-.003-.386.38-.76.774-1.153 1.148-.366.348-.552.77-.59 1.267-.06.803.137 1.563.413 2.305.57 1.535 1.437 2.895 2.487 4.143 1.417 1.688 3.114 3.025 5.098 3.99.892.432 1.82.766 2.824.82.69.04 1.295-.135 1.777-.674z'
        }, this.getPathProps()))
      );
    }
  }]);
  return Phone;
}(_BaseIcon3.default);
/*eslint-enable */


Phone.defaultProps = {
  width: 15,
  height: 15,
  viewBox: '58 101 15 15'
};
exports.default = Phone;
//# sourceMappingURL=Phone.js.map


//////////////////
// WEBPACK FOOTER
// ../icon/lib/Icons/Phone.js
// module id = 313
// module chunks = 0